import { useCallback, useEffect, useState } from "react";

const KAKAO_API_KEY = process.env.REACT_APP_KAKAO_API_KEY;

const useKakaoChannel = () => {
  const [kakaoChannel, setKakaoChannel] = useState("");

  useEffect(() => {
    try {
      const script = document.createElement("script");
      script.src = "https://developers.kakao.com/sdk/js/kakao.js";
      script.async = true;
      script.onload = () => {
        Kakao.init(KAKAO_API_KEY);
        Kakao.isInitialized();
        setKakaoChannel(Kakao);
      };
      document.body.appendChild(script);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleClickOpenKakao = useCallback(() => {
    const deviceInfo = navigator.userAgent;
    if (deviceInfo.includes("Android")) {
      Kakao.Channel.chat({
        channelPublicId: "_WaLZC",
      });
    } else {
      window.open("https://pf.kakao.com/_WaLZC/chat", "kakaoChannel");
    }
  }, [kakaoChannel]);

  const shareKakaoMessage = ({ title, description, imageUrl, url }) => {
    Kakao.Share.sendDefault({
      objectType: "feed",
      content: {
        title: title,
        description: description,
        imageUrl: imageUrl,
        link: {
          mobileWebUrl: url,
          webUrl: url,
        },
      },
      buttons: [
        {
          title: "bodycodi+ 에서 보기",
          link: {
            mobileWebUrl: url,
            webUrl: url,
          },
        },
      ],
    });
  };

  return { handleClickOpenKakao, shareKakaoMessage };
};

export default useKakaoChannel;
